<div fxShow.gt-sm fxHide.lt-md fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center center center">
        <mat-toolbar class="toolbarNav" fxLayoutAlign="center center center">

            <div fxLayout="row"
                 ngStyle.lt-lg="width:90%"
                 ngStyle.lg="width:96%"
                 ngStyle.gt-lg="width:76%">

                <div fxLayoutAlign="start center center" class="logo-container" style="cursor: pointer;">
                    <img src="assets/images/econsent_logo_final.png" alt="Consent Logo" style="height: 55px; width: auto;"/>
                </div>

                <div *ngIf="!loading" fxHide.lt-md fxFlex="grow" class="navigationButtons2"
                     fxLayoutAlign="end center center">

                    <div fxLayout="column" style="width: 100px; cursor: pointer;" routerLinkActive="router-link-active"
                         *ngFor="let item of navigationItems; let i = index" [routerLink]="item.path"
                         [style.animation-delay]="(i * 0.1) + 's'"
                         class="animate-fade-in-up">
                        <mat-icon
                                class="nav-icon"
                                style="margin-bottom: -2px; margin-left: auto; margin-right:auto;"
                                *ngIf="item.imageType && item.imageType==='icon'">{{item.image}}</mat-icon>
                        <span class="nav-text" style="font-size: 12px; text-align: center;">{{item.title}}</span>

                    </div>

                </div>
            </div>
        </mat-toolbar>
    </div>

    <ng-container *ngIf="pageLoaded && !isMobile then ShowRouterOutlet"></ng-container>
</div>



<!--#region Mobile Ui-->
<div fxShow.lt-md fxHide.gt-sm class="mobile-ui">
    <mat-drawer-container [hasBackdrop]="true">

        <mat-drawer #drawer [mode]="'over'" class="drawer">

            <mat-toolbar class="drawer-header" style="background: linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%);">
                <span fxFlex="100"></span>
                <mat-icon style="color: white; cursor: pointer;" (click)="drawer.toggle()">close</mat-icon>
            </mat-toolbar>

            <div fxLayout="column" style="padding-top: 10px;">
                <div fxLayout="column" style="padding: 0.5rem 1rem; border-bottom: 1px solid var(--tertiary);">
                    <mat-list role="list">
                        <mat-list-item class="mobile-nav-item animate-fade-in-up stagger-1" (click)="navigateTo('main', drawer)">
                            <mat-icon style="color: var(--accent); margin-right: 12px;">assignment</mat-icon>
                            <span>Διαθέσιμες δηλώσεις</span>
                        </mat-list-item>
                        <mat-list-item class="mobile-nav-item animate-fade-in-up stagger-2" role="listitem" (click)="navigateTo('mobile-parent-consents', drawer)">
                            <mat-icon style="color: var(--accent); margin-right: 12px;">family_restroom</mat-icon>
                            <span>Δηλώσεις Γονέα</span>
                        </mat-list-item>
                        <mat-list-item class="mobile-nav-item animate-fade-in-up stagger-3" role="listitem" (click)="navigateTo('mobile-child-history-consents', drawer)">
                            <mat-icon style="color: var(--accent); margin-right: 12px;">history</mat-icon>
                            <span>Ιστορικό</span>
                        </mat-list-item>
                        <mat-list-item class="mobile-nav-item animate-fade-in-up stagger-4" role="listitem" (click)="navigateTo('mobile-parent-messages', drawer)">
                            <mat-icon style="color: var(--accent); margin-right: 12px;">mail</mat-icon>
                            <span>Τα μηνύματά μου</span>
                        </mat-list-item>
                    </mat-list>
                </div>

                <div fxLayout="row" style="padding: 1rem;">
                    <mat-list role="list" style="width: 100%;">
                        <mat-list-item class="mobile-nav-item logout-item animate-fade-in-up stagger-5" role="listitem" (click)="promptLogout()">
                            <mat-icon style="color: var(--danger); margin-right: 12px;">logout</mat-icon>
                            <span style="color: var(--danger);">Αποσύνδεση</span>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>

        </mat-drawer>
        <mat-drawer-content fxLayout="column"
                            style="background-color: var(--secondary); padding:0 !important; margin: 0!important; height: 100vh;">
            <mat-toolbar class="mobile-toolbar" style="background: linear-gradient(135deg, var(--primary) 0%, var(--primary-light) 100%);">

                <mat-icon (click)="drawer.toggle()" style="cursor: pointer;">menu</mat-icon>

                <span fxFlex="100" fxLayoutAlign="center center"
                      style="color: white; font-family: 'Century Gothic', sans-serif; font-weight: 500;">{{headerTitle}}</span>
                <mat-icon (click)="showBottomSheet()" style="cursor: pointer;">sort_by_alpha</mat-icon>
            </mat-toolbar>

            <div fxLayout="row" style="padding: 1rem;" fxFlex="100">
                <ng-container *ngIf="pageLoaded && isMobile then ShowRouterOutlet"></ng-container>
            </div>
        </mat-drawer-content>

    </mat-drawer-container>


</div>
<!--#endregion-->


<ng-template #ShowRouterOutlet>
    <div [ngStyle.lt-md]="{'margin-top': '0px'}" style="margin-top:60px; min-height: calc(100vh - 60px);">
        <router-outlet></router-outlet>
    </div>
</ng-template>
